<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/Mappe tematiche/Mappe_tematiche_top.jpg">
<div class="content">
    <h1>Mappe Tematiche</h1>
</div>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            Per conoscere la Calabria in tutte le diverse identità culturali e paesaggistiche che la connotano, 
            proponiamo una serie di cinque mappe tematiche che offrono la possibilità di godere di un quadro d’insieme del patrimonio fruibile di questa magnifica 
            regione del sud dell’Italia.
            <br>
            <br>
            Si tratta di Parchi e Riserve, Siti Unesco, Borghi storici, Musei e siti archeologici, Luoghi d’arte, storia e spiritualità, 
            cinque mappe in cui cogliere la straordinaria varietà dell’offerta turistica della Calabria, un invito a progettare il viaggio in funzione dei propri interessi, 
            nella consapevolezza che questa terra offre motivi di attrazione per tutti e uno spirito di accoglienza oltre ogni luogo  comune.
        </p>
    </div>
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>